import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "liveagent",
  "use": "liveagent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 1024 1024\" id=\"liveagent\"><path fill=\"currentColor\" d=\"M955.313 255.75v512.1l-126.775 72.986v-511.5L511.6 146.17 194.462 329.336l.8 511.7L68.687 767.85v-511.7L512.4 0zM575.188 840.836 512 877.629l-63.588-36.393v-511.9L321.837 402.52l.2 511.7L511.8 1024l190.163-109.779v-511.9l-126.775-73.185z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol